import React from 'react';
import { motion } from 'framer-motion';
import { FaUserCog, FaMoneyCheckAlt, FaLock, FaUserMd, FaRegHospital, FaCapsules } from "react-icons/fa";
import DigitalTransformation from './Digital';
import HealthcareTransformation from './HealthcareTransformation';
import Demo from '../../Demo';
import { Outlet, useNavigate } from 'react-router-dom';
import Footer from '../../Component/Fooder';

function Frame3() {
  const services = [
    { title: "Healthcare Software Development", desc: " Offering tailored solutions for clinical, provider, patient, and payer management, enhancing interoperability and system integration.", icon: <FaUserCog />, route: "/Services/Healthsoftware" },
    { title: "Interoperability Solutions", desc: "Expertise in ensuring seamless data exchange between healthcare systems, enhancing efficiency, and promoting patient-centered care.", icon: <FaMoneyCheckAlt />, route: "/Services/InteroperabilitySolutions" },
    { title: "Provider & Payer Systems ", desc: "Supporting the development and optimization of healthcare solutions for providers and payers, streamlining processes and improving patient outcomes", icon: <FaLock />, route: "/Services/Provider&PayerSystems" },
    { title: "Clinical Systems", desc: " Helping clinical organizations develop and implement software solutions to support electronic health records (EHR), patient management, and clinical workflows.", icon: <FaUserMd />, route: "/Services/ClinicalSystems" },
    { title: "Patient-Centered Software Solutions", desc: "Focused on building user-friendly and secure applications for improved patient engagement, care coordination, and healthcare outcomes.", icon: <FaRegHospital />, route: "/Services/Patient-CenteredSoftwareSolutions" },
    { title: "Health Data Security & Compliance", desc: " Ensuring robust data security and HIPAA compliance with solutions that safeguard patient information and streamline electronic health data sharing.", icon: <FaCapsules />, route: "/Services/HealthDataSecurity&Compliance" }
  ];

  return (
    <>
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="bg-white flex flex-col w-full box-border"
      >
        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="p-6 md:p-12 self-start text-center text-[25px] tracking-wide font-bold text-[#03ab3b]"
        >
          Our Healthcare
          <span className="font-bold text-[#2a627a] text-2xl ml-3">
            Services
          </span>
        </motion.div>

        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="px-6 md:px-12 text-center text-[15px] font-normal text-black bg-gradient-to-r from-[#2a627a] to-transparent bg-opacity-100 backdrop-blur-lg p-4 rounded-lg shadow-lg transition-all duration-300"
        >
          We are committed to providing high-quality, patient-centered healthcare services to ensure your well-being.
        </motion.div>

        <div className="p-1 grid grid-cols-1 self-center m-8 md:grid-cols-2 lg:grid-cols-3 gap-6 w-auto">
          {services.map((service, index) => (
            <motion.div
              className="relative z-10"
              key={index}
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              <ServiceBox title={service.title} description={service.desc} icon={service.icon} route={service.route} />
            </motion.div>
          ))}
        </div>

        <div>
          <DigitalTransformation />
        </div>
        <div> <Demo /></div>
        <div>
          <HealthcareTransformation />
        </div>
        <Outlet />
      </motion.div>
      <Footer />
    </>
  );
}

const ServiceBox = ({ title, description, icon, route }) => {
  const navigate = useNavigate();

  return (
    <div className="group relative flex flex-col items-center justify-between p-6 h-full w-full md:w-[300px] rounded-xl border border-gray-200 shadow-xl bg-gray-300 bg-opacity-70 backdrop-blur-lg transition-all duration-300 hover:shadow-2xl hover:bg-opacity-100">
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-[#2a627a] to-[#03ab3b] text-white text-3xl shadow-lg mb-4 transition-all duration-300 hover:scale-110">
        {icon}
      </div>
      <h3 className="text-center font-bold text-lg text-gray-800 tracking-wide leading-snug mb-3">
        {title}
      </h3>
      <p className="text-center text-sm text-gray-800 leading-relaxed flex-grow">
        {description}
      </p>
      <div className="absolute inset-0 rounded-xl border-2 border-transparent hover:border-green-500 transition-all duration-300"></div>
      <button
        onClick={() => navigate(route)}
        className="relative mt-2 bg-gradient-to-r from-[#2a627a] to-green-700 text-white px-8 py-2 rounded-full shadow-xl hover:from-[#2a627a] hover:to-green-600 hover:scale-110 transition-all duration-300 ease-in-out transform flex items-center gap-3 overflow-hidden before:absolute before:w-0 before:h-full before:bg-white/20 before:left-0 before:top-0 before:transition-all before:duration-500 hover:before:w-full"
      >
        <span className="relative z-10 font-semibold text-lg tracking-wide">Explore More</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="relative w-6 h-6 transition-transform duration-300 group-hover:translate-x-2"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5l6 6m0 0l-6 6m6-6H4.5" />
        </svg>

        <div className="absolute inset-0 w-full h-full bg-green-400/20 opacity-0 transition-opacity duration-500 rounded-full blur-lg group-hover:opacity-100"></div>
      </button>
    </div>
  );
};

export default Frame3;
